








import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import BlurredTenant from '@/components/BlurredTenant.vue';
import * as _ from 'lodash';




export default Vue.extend({
    components: { BlurredTenant },
    data() {
        return {
            showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
            tableOptions: {
                attrs: {
                    "item-key": "_id",
                    "sort-by": "createdTime",
                    "sort-desc": true,
                },
                content: {
                    name: "Voucher History",
                    search: {
                        ext: {
                            hidden: true,
                        },
                    },
                    filters: {
                        filters: {
                            tenantId: userManager.checkRole(["systemAdmin", "admin"]) && {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "Organization",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "name",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call("tenants", "findAll", {
                                                    payload: JSON.stringify({
                                                        limit,
                                                        search,
                                                        orderBy: "name",
                                                        orderType: "asc",
                                                        filters: [
                                                            {
                                                                key: "_id",
                                                                operator: "equal_to",
                                                                value,
                                                            },
                                                        ],
                                                    }),
                                                });
                                                return items;
                                            },
                                        },
                                    },
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            "targetAfter.userId": userManager.checkRole(["systemAdmin", "admin", "cpoAdmin", "cpoMonitor"]) && {
                                type: "XAutocomplete",
                                attrs: {
                                    label: "User",
                                    required: true,
                                    "item-value": "_id",
                                    "item-text": "email",
                                    xOptions: {
                                        content: {
                                            async itemsSuggestor(search, value, limit) {
                                                const { items } = await coreApiClient.call("users", "findAllUser", {
                                                    payload: JSON.stringify({
                                                        limit,
                                                        search,
                                                        orderBy: "email",
                                                        orderType: "asc",
                                                        filters: [
                                                            {
                                                                key: "_id",
                                                                operator: "equal_to",
                                                                value,
                                                            },
                                                        ],
                                                        extraParams: {
                                                            searchCrossTenant: !!search && true
                                                        }
                                                    }),
                                                });
                                                return items;
                                            },
                                        },
                                    },
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            actionType: {
                                type: "select",
                                attrs: {
                                    label: "Action Type",
                                    items: [
                                        { text: "Create", value: "Create" },
                                        { text: "Update", value: "Update" },
                                        { text: "Delete", value: "Delete" },
                                    ],
                                },
                                rules: {
                                    equal_to: {},
                                },
                            },
                            createdTime: {
                                type: "XDateTimePicker",
                                rules: {
                                    greater_than_or_equal_to: {
                                        attrs: {
                                            label: "Action Time (From)",
                                        },
                                    },
                                    less_than_or_equal_to: {
                                        attrs: {
                                            label: "Action Time (To)",
                                        },
                                    },
                                },
                            },
                            serialNumber: {
                                type: "text",
                                attrs: {
                                    label: "Serial Number",
                                },
                                rules: {
                                    match: {},
                                },
                            },
                        },
                    },
                    displayFields: {
                        user: userManager.checkRole(["systemAdmin", "admin"]) && {
                            text: "Tenant",
                            options: {
                                label: true,
                                transform: (data, item) => {
                                    return item?.targetAfter?.tenant?.name || item?.targetBefore?.tenant?.name;
                                },
                            },
                        },
                        code: userManager.checkRole(["systemAdmin", "admin"]) && {
                            text: "Code",
                            options: {
                                label: true,
                                transform: (data, item) => {
                                    return item?.targetAfter?.code || item?.targetBefore?.code;
                                },
                            },
                        },
                        serialNumber: userManager.checkRole(["systemAdmin", "admin"]) && {
                            text: "Serial Number",
                            options: {
                                label: true,
                                transform: (data, item) => {
                                    return item?.targetAfter?.serialNumber || item?.targetBefore?.serialNumber || '';
                                },
                            },
                        },
                        // startTime: userManager.checkRole(["systemAdmin", "admin"]) && {
                        //     text: "Start Time",
                        //     options: {
                        //         label: true,
                        //         transform: (data, item) => {
                        //             return new Date(item?.targetAfter?.startTime || item?.targetBefore?.startTime).toLocaleString("en-GB");
                        //         },
                        //     },
                        // },
                        // endTime: userManager.checkRole(["systemAdmin", "admin"]) && {
                        //     text: "End Time",
                        //     options: {
                        //         label: true,
                        //         transform: (data, item) => {
                        //             return new Date(item?.targetAfter?.endTime || item?.targetBefore?.endTime).toLocaleString("en-GB");
                        //         },
                        //     },
                        // },
                        actionBy: {
                            text: "Action By",
                            options: {
                                subProp: "user.email",
                                label: true,
                            },
                        },
                        actionType: {
                            text: "Action Type",
                            options: {
                                label: true,
                                attrs(value) {
                                    const colors = {
                                        Create: "green",
                                        Update: "blue",
                                        Delete: "red",
                                    };
                                    return {
                                        color: colors[value] || "gray"
                                    };
                                },
                            },
                        },
                        before: {
                            text: "Before",
                            options: {
                                transform: (data, item) => {
                                    return this.formatData(item.targetBefore);
                                },
                            },
                        },
                        after: {
                            text: "After",
                            options: {
                                transform: (data, item) => {
                                    return this.formatData(item.targetAfter, item.targetBefore);
                                },
                            },
                        },
                        createdTime: {
                            text: "Action Time",
                            options: {
                                transform: (data) => {
                                    return new Date(data).toLocaleString("en-GB");
                                },
                            },
                        },
                    },
                    topActionButtons: {

                    },
                    findAllOptionsFilter(options) {
                        options.filters.push({
                            key: "targetType",
                            operator: "equal_to",
                            value: 'Voucher',
                        });
                        return options;
                    },
                },
                ext: {
                    dataProvider: {
                        async findAll(options) {
                            const { items, count } = await coreApiClient.call("actionLogs", "findAll", options);
                            return [items, count];
                        }
                    }
                },
            },
        };
    },
    methods: {
        getDifferences(obj1, obj2) {
            const differences = {};
            _.union(_.keys(obj1), _.keys(obj2)).forEach((key) => {
                if (!_.isEqual(obj1[key], obj2[key])) {
                    differences[key] = true;
                }
            });
            return differences;
        },
        differenceColor(isDifferent) {
            return isDifferent ? 'style="color: red;"' : '';
        },
        formatData(data: any = {}, before) {
            const compareData = [
                'code', 'status', 'amount', 'startTime', 'endTime'
            ];

            data = _.pick(data, compareData);
            let differences = {};
            if (before) {
                before = _.pick(before, compareData);
                differences = this.getDifferences(before, data);
            }

            const formatField = (label, field, formatter = (v) => v || '') => {
                if (data[field] == null) { return ''; }
                return `
                <div ${this.differenceColor(differences[field])}>
                    <b>${label}:</b> ${formatter(data[field])}
                </div>
            `;
            };

            return `
            <div>
                ${formatField('status', 'status', (v) => _.upperFirst(v))}
                ${formatField('Amount', 'amount')}
                ${formatField('Start Time', 'startTime', (v) => new Date(v).toLocaleString("en-GB"))}
                ${formatField('End Time', 'endTime', (v) => new Date(v).toLocaleString("en-GB"))}
            </div>
        `;
        },
    }
});

